
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'reference',
  skipLLM: true,
  description: 'Find partners who work with Plaid Transactions'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Transactions partners' subtitle={metadata.description} mdxType="Header" />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`The following is a list of companies who have partnered with Plaid to provide Transactions capabilities via a special processor token, along with instructions on how to enable those integrations.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Partner`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/docs/transactions/partnerships/atomic-financial"
            }}>{`Atomic Financial`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Use Atomic and Plaid to pull user transactions and identify a user's payroll and subscriptions`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/docs/transactions/partnerships/boom"
            }}>{`Boom`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Report your customers' rent payments to Experian, Equifax, and TransUnion using the bank account they've linked via Plaid in your platform`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/docs/transactions/partnerships/cardlytics"
            }}>{`Cardlytics`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Turn your customers' everyday purchases into personalized cashback rewards with the Cardlytics Rewards Platform`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/docs/transactions/partnerships/esusu"
            }}>{`Esusu`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Report positive-only rent payments to Experian, Equifax, and TransUnion with Esusu and Plaid`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/docs/transactions/partnerships/knot"
            }}>{`Knot`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Instantly make your card top-of-wallet at merchants with Knot's API`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/docs/transactions/partnerships/layer"
            }}>{`Layer`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Offer SMB accounting embedded directly within your platform`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/docs/transactions/partnerships/pinwheel"
            }}>{`Pinwheel`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Activate new accounts with the industry's top performing direct deposit and bill switching solution, The Pinwheel Switch Kit`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/docs/auth/partnerships/sardine"
            }}>{`Sardine`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Protect your users by using Sardine's all-in-one fraud and compliance API`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/docs/transactions/partnerships/teal"
            }}>{`Teal`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Teal allows SMB vertical SaaS and neobanks to build and offer their own branded accounting suite to their SMB customers`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`For more information, see the full list of partners in the `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/developers/integrations"
      }}>{`Plaid Dashboard`}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
